import { routesNames } from '@/core/constants'
import ModalDesentranhamento from '@/views/pages/ata/acessar/gestao-da-ata/documentos/desentranhamento/ModalDesentranhamento.vue'
import desentranhamentoRoutes from '@/views/routers/routes/ata/processo-digital/desentranhamento/desentranhamento'

export default [
	{
		name: routesNames.ATA.PROCESSO_DIGITAL.DESENTRANHAMENTO.DESENTRANHAR_DOCUMENTO_PROCESSO_DIGITAL_VIEW,
		path: '/ata/:idAta/processo-digital/:idTermo/desentranhar/',
		component: ModalDesentranhamento,
		children: [...desentranhamentoRoutes],
	},
]
